function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS20KreisGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    width: 150,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8500000238418579
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.8,75.78974c0,.67-.02,1.33-.05,1.99005a38.79773,38.79773,0,0,1-77.55-1.88c0-1.24.06-2.46.17-3.67h.19a36.87434,36.87434,0,0,0,5.5-.43c1.11-.18,2.21-.4,3.28-.68a35.202,35.202,0,0,0,10.06-4.29,36.0163,36.0163,0,0,0,16.41-24.06,36.63067,36.63067,0,0,0,.57-5.58c.21-.02.42-.03.62-.04.66-.03,1.33-.05,2-.05h.18c.27,0,.55,0,.82.00995.67.02,1.33.05,1.99.1.33.02.66.05.98.09a38.8119,38.8119,0,0,1,34.72,35.62l.06.9C113.78,74.46979,113.8,75.12977,113.8,75.78974Z",
    style: {
      fill: "#ea516c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.75,73.81977v-.02c-.02-.29-.04-.59-.06-.88v-.08c-.01-.13-.02-.25-.04-.38-.01-.13-.03-.25-.04-.38,0-.04-.01-.07-.01-.11-.01-.05-.01-.09-.02-.14-.03-.3-.06-.62-.1-.92-.06-.44-.12-.87006-.19-1.31-.04-.27-.1-.54-.15-.82-.06-.33-.11-.68-.19-1.02a.2199.2199,0,0,0-.01-.08c-.09-.43-.19-.86-.29-1.29-.18-.71-.38-1.42-.59-2.11-.19-.59-.39-1.18-.6-1.76a.03676.03676,0,0,0-.01-.03c-.21-.58-.44-1.15-.68-1.72-.12-.29-.25-.58-.38-.87-.26-.59-.53-1.16-.82-1.72-.29-.54-.58-1.08-.88-1.61a.07544.07544,0,0,0-.02-.04c-.46-.8-.94-1.57-1.46-2.33-.17-.26-.34-.52-.53-.77-.36-.5-.73-1-1.11-1.49-.39-.5-.79-.99-1.21-1.47-.6-.68005-1.21-1.34-1.84-1.98l-.06-.06c-.42-.43-.86-.84-1.3-1.24a37.34736,37.34736,0,0,0-4.43-3.49c-1.01-.67-2.06-1.31-3.13-1.9-.41-.23-.82-.44-1.24-.65-1.26-.62-2.56-1.18-3.89-1.68a.48556.48556,0,0,0-.07-.03q-.48-.18-.96-.33c-.56-.18-1.13-.35-1.7-.5-.41-.12-.83-.23-1.24-.33-.21-.06-.42-.11-.63-.16-.3-.07-.6-.16-.9-.22-.36-.08-.73-.15-1.1-.21-.29-.05-.59-.1-.88-.14-.67-.1-1.34-.18-2.02-.25-.32-.04-.65-.07-.98-.09-.27-.03-.55-.05-.82-.06-.38995-.02-.78-.04-1.17-.04a3.388,3.388,0,0,0-.45-.00995H74.6a4.05477,4.05477,0,0,0-.49.00995h-.2c-.31.01-.61.03-.91.04-.2.01-.41.02-.62.04a36.63194,36.63194,0,0,1-.57,5.58c1.05-.11,2.11-.16,3.19-.17a33.2,33.2,0,1,1-33.2,33.2,35.20444,35.20444,0,0,1,.26-4,36.87178,36.87178,0,0,1-5.5.43h-.19c-.11,1.21-.17,2.43007-.17,3.67a38.79826,38.79826,0,0,0,38.79652,38.8H75c.36,0,.72,0,1.07-.01q.87-.03,1.74-.09c.35-.02.69-.05,1.04-.09.57-.05,1.15-.12,1.72-.21.3-.04.6-.09.9-.13995s.6-.1.9-.16l.6-.12c.49-.1.97-.21,1.45-.33q.45-.11994.9-.24a38.749,38.749,0,0,0,4.37-1.49c.28-.11.57-.23.85-.36.56-.24,1.1-.49,1.65-.77.24-.11.47-.23.71-.35a38.97128,38.97128,0,0,0,10.28-7.77c.18-.18.35-.37.52-.56a38.01482,38.01482,0,0,0,4.83-6.58c.15-.25.3-.51.43994-.77.22-.4.44-.8.64-1.21.13-.26.27-.52.39-.79.16-.32.31-.64.45-.97.1-.21.19-.43.28-.65.31-.73.6-1.47.86005-2.22.09-.24.17-.48.25-.72.21-.64.41-1.28.57995-1.93.06-.23.12-.45.18-.68.18-.71.35-1.44.48-2.17a.01386.01386,0,0,1-.00039-.0196l.00039-.0004c.14-.67.25-1.35.34-2.04.07-.52.14-1.04.19-1.57.06-.64.11-1.27.14-1.91.03-.66.05-1.32.05-1.99C113.8,75.12977,113.78,74.46979,113.75,73.81977Z",
    style: {
      fill: "#ea516c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3,81.0998c0,5-4.1,7.9-9.7,7.9-7.1-.2-10.9-3.1-11.2-8.4h5c.3,2.9,2.1,4.1,5.6,4.1,2.6,0,5-.9,5-3.2,0-2.4-2.4-2.9-6.2-3.8-4.15-.85-8.03-2.23-8.46-6.58a34.63157,34.63157,0,0,0,4.98-1.66.97243.97243,0,0,0-.02.24c0,2.1,1.8,2.6,5.6,3.5C61.2,74.39979,65.3,75.5998,65.3,81.0998Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,66.82978a36.15083,36.15083,0,0,0,4.47-3.28,7.51571,7.51571,0,0,1,4.83,7.05h-5C59.43,68.23975,57.67,67.02979,55.4,66.82978Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4,78.5c2.9-2.4,6.5-4.1,6.5-7.1,0-2.4-1.2-3.8-3.2-3.8-2.4,0-3.8,1.8-3.8,5H69.5c0-5.6,2.9-9.1,8.5-9.1,5.3,0,8.2,3.5,8.2,7.6,0,4.4-3.2,6.8-6.2,8.8-1.8,1.2-4.1,2.6-5,4.4H86.2v3.8H68.8C68.8,83.5,71.8,80.9,74.4,78.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8,76.2c0-7.6,4.1-12.6,10-12.6,6.2,0,10,5,10,12.6s-3.8,12.6-10,12.6S86.8,83.8,86.8,76.2Zm15.3,0c0-5-1.5-8.5-5-8.5s-5,3.5-5,8.5,1.5,8.5,5,8.5S102.1,81.5,102.1,76.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.12,37.19977c.09,0,.18-.01.26-.01v-.01A2.11012,2.11012,0,0,1,72.12,37.19977Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.51887,37.19977c.09,0,.18-.01.26-.01v-.01A2.11012,2.11012,0,0,1,.51887,37.19977Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.89553,36.30219a30.9501,30.9501,0,1,1,0-.00023Z",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.62112,37.19977c.09,0,.18-.01.26-.01v-.01A2.11012,2.11012,0,0,1,71.62112,37.19977Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.95088,17.19489A15.46416,15.46416,0,0,0,20.47716,32.65767c0,12.02845,15.47372,22.90019,15.47372,22.90019S51.41372,43.9541,51.41372,32.65767A15.46183,15.46183,0,0,0,35.95088,17.19489ZM35.95176,39.884a7.62,7.62,0,1,1,7.62-7.62A7.62874,7.62874,0,0,1,35.95176,39.884Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.62792,13.47554,58.96618,53.56676,54.8239,57.44361,14.056,17.19489Z",
    style: {
      fill: "#ec0016"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.94553,10.352A25.95009,25.95009,0,1,1,9.99535,36.302a25.97961,25.97961,0,0,1,25.95018-25.95m0-5a30.95009,30.95009,0,1,0,30.95,30.95019V36.302a30.95006,30.95006,0,0,0-30.95-30.95Z",
    style: {
      fill: "#ec0016"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15009,36.30219a30.9501,30.9501,0,1,1,0-.00023Z",
    style: {
      fill: "#353535"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.20544,17.19489A15.46416,15.46416,0,0,0,20.73172,32.65767c0,12.02845,15.47372,22.90019,15.47372,22.90019S51.66828,43.9541,51.66828,32.65767A15.46184,15.46184,0,0,0,36.20544,17.19489ZM36.20631,39.884a7.62,7.62,0,1,1,7.62-7.62A7.62873,7.62873,0,0,1,36.20631,39.884Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.88247,13.47554,59.22074,53.56676l-4.14229,3.87685L14.31052,17.19489Z",
    style: {
      fill: "#ec0016"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.20008,10.352A25.95009,25.95009,0,1,1,10.2499,36.302a25.97961,25.97961,0,0,1,25.95018-25.95m0-5a30.95009,30.95009,0,1,0,30.95,30.95019V36.302a30.95008,30.95008,0,0,0-30.95-30.95Z",
    style: {
      fill: "#353535"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS20KreisGray);
export default __webpack_public_path__ + "static/media/s20kreis-gray.f06e7e907e40080387d95a71ca7b2e2c.svg";
export { ForwardRef as ReactComponent };